import React from "react";
import Radio from "../form/Radio";
import { classNames } from "../../helpers/classNames";

const QuizAnswerButton = ({ data = {}, selectAnswerHandler = () => {} }) => {
  return (
    <Radio
      radioName={"answer"}
      className={classNames(
        "font-CanelaDeck relative overflow-hidden flex justify-center items-center gap-2 text-white text-base py-0 transition-all duration-200 h-8 xls:h-11 rounded-full px-6 xls:px-10 [&>input~div.w-5]:hidden",
        data?.checked
          ? "bg-chestnut-rose outline-1 outline-offset-2 outline-dashed outline-chestnut-rose"
          : "bg-gable-green hover:bg-blue-zodiac"
      )}
      radioInputClass={"hidden"}
      radioLabel={data?.title || ""}
      radioLableClass={
        "text-base xls:text-lg text-white whitespace-nowrap !ml-0"
      }
      isChecked={data?.checked}
      value={data?._id}
      onChange={(e) => {
        selectAnswerHandler({
          answer: e.target.value,
          checked: e.target.checked,
          name: e.target.name,
        });
      }}
    />
  );
};

export default QuizAnswerButton;
